import { render, staticRenderFns } from "./createGalleryStandard.vue?vue&type=template&id=38957a30&scoped=true&"
import script from "./createGalleryStandard.vue?vue&type=script&lang=js&"
export * from "./createGalleryStandard.vue?vue&type=script&lang=js&"
import style0 from "./createGalleryStandard.vue?vue&type=style&index=0&id=38957a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38957a30",
  null
  
)

export default component.exports